import PropTypes from 'prop-types';
import React from 'react';
import onClickOutside from 'react-onclickoutside';
import { page as pageIndex } from '../../../globals';
import STSComponent from "../../STSComponent/STSComponent";
import CheckboxesList from '../CheckboxesList/CheckboxesList';

class CustomDropdown extends STSComponent {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: false,
    }
    this.toggleOpen = this.toggleOpen.bind(this)
    this.uncheckAll = this.uncheckAll.bind(this)
    this.checkAll = this.checkAll.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return JSON.stringify(nextProps) !== JSON.stringify(this.props) ||
      nextState.isOpen !== this.state.isOpen
  }

  handleClickOutside = (evt) => {
    this.setState({
      isOpen: false,
    })
  }

  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  uncheckAll = () => {
    const { location, updateData, uncheckAll } = this.props
    if (uncheckAll !== undefined) {
      updateData(location, 'ch_uncheckall_gn', uncheckAll)
    } else {
      updateData(location, 'ch_uncheckall')
    }
  }

  checkAll = () => {
    const { location, updateData, fieldData } = this.props
    let statesList = []
    let localitiesList = []
    for (let i = 0; i < fieldData.length; i++) {
      if (!statesList.includes(fieldData[i]['id'])) {
        if (fieldData[i].locality !== undefined) {
          for (let j = 0; j < fieldData[i].locality.length; j++) {
            localitiesList = [...localitiesList, fieldData[i].locality[j].id]
          }
        }
        statesList = [...statesList, fieldData[i]['id']]
      }
    }
    updateData(location, 'ch_selectall', [...statesList, ...localitiesList])
  }

  render () {
    const { fieldData, location, values, inputPlaceholder, updateData } = this.props
    const { isOpen } = this.state
    return (
      <div className="customdropdown-field">
        <div className="Select-control" onClick={this.toggleOpen}>
          <div className="Select-value">
            <span className="Select-value-label">{inputPlaceholder}</span>
          </div>
          <span className="Select-arrow-zone">
            <span className="Select-arrow" />
          </span>
        </div>
        <div className={isOpen ? 'Select-menu-outer' : 'Select-menu-outer hidden'} >
          <div className="checkboxes-container greyed-checkbox-bg">
            <CheckboxesList
              location={location}
              fieldData={fieldData}
              values={values}
              updateData={updateData}
            />
          </div>
          <div className="customdropdown-buttons">
            <button
              className={location.page === pageIndex.cmd
                ? 'green'
                : values.selected.length !== 0
                  ? 'green'
                  : 'green disable-button'}
              onClick={location.page === pageIndex.cmd ? this.checkAll : this.uncheckAll}
            >
              {location.page === pageIndex.cmd ? 'Check all' : 'Uncheck all'}
            </button>
            <button className="blue" onClick={this.toggleOpen}>Done</button>
          </div>
        </div>
      </div>
    )
  }
  static propTypes = {
    values: PropTypes.object.isRequired,
    updateData: PropTypes.func,
    fieldData: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    inputPlaceholder: PropTypes.string,
    uncheckAll: PropTypes.number,
  }
}

export default onClickOutside(CustomDropdown)



// WEBPACK FOOTER //
// ./src/components/FormComponents/MultiSelect/CustomDropdown.js